import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectArrow extends PageObject {
  direction: number;

  constructor(obj: PageObjectArrow = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.Arrow;

    if (obj == null) {
      this.direction = 0;
    } else {
      this.direction = obj.direction;
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    let border = new ObjectProperty("Direction", OBJECTPROPERTYTYPE.List);
    border.addOption("0", "Left");
    border.addOption("1", "Right");
    border.addOption("2", "Top");
    border.addOption("3", "Bottom");
    list.push(border);

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Direction") {
      return this.direction + "";
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Direction") {
      this.direction = +value;
    }
  }
}
